/*
 * Cart insurance toggle — Vunika (FullStack / Horizon base)
 * Assurance colis pré-cochée (opt-out, auto-ajout) sur la PAGE panier ET le
 * panier coulissant (drawer).
 *   - Page  : recharge après add/remove (comme la version Minopia).
 *   - Drawer: rafraîchi via l'évènement 'cart:updated' + Section Rendering API
 *             (pas de reload, le drawer reste ouvert).
 * Accroché aux blocs cross-sell portant la classe .cart-insurance-toggle.
 */
(function () {
  'use strict';
  var SCOPE = '.cart-insurance-toggle';
  var ADD = '/cart/add.js', CHANGE = '/cart/change.js', CART = '/cart.js';
  var autoTried = {};

  (function injectCss() {
    if (document.querySelector('style[data-cart-ins-toggle]')) return;
    var s = document.createElement('style');
    s.setAttribute('data-cart-ins-toggle', '1');
    s.textContent =
      SCOPE + '.hidden{display:block !important}' +
      SCOPE + ' .cross-sell__form .button{display:none !important}' +
      SCOPE + ' .cart-ins-switch{position:relative;display:inline-block;width:46px;height:26px;flex:0 0 auto;margin:0}' +
      SCOPE + ' .cart-ins-switch__input{opacity:0;width:0;height:0;position:absolute;margin:0}' +
      SCOPE + ' .cart-ins-switch__slider{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background:#ccc;border-radius:26px;transition:background .25s}' +
      SCOPE + ' .cart-ins-switch__slider::before{content:"";position:absolute;height:20px;width:20px;left:3px;top:3px;background:#fff;border-radius:50%;transition:transform .25s;box-shadow:0 1px 3px rgba(0,0,0,.3)}' +
      SCOPE + ' .cart-ins-switch__input:checked + .cart-ins-switch__slider{background:#1b1b1b}' +
      SCOPE + ' .cart-ins-switch__input:checked + .cart-ins-switch__slider::before{transform:translateX(20px)}' +
      SCOPE + ' .cart-ins-switch__input:disabled + .cart-ins-switch__slider{opacity:.55;cursor:default}';
    document.head.appendChild(s);
  })();

  function drawerOf(node){ return node.closest ? node.closest('cart-drawer') : null; }
  function drawerSectionId(){ var d = document.querySelector('cart-drawer'); return d ? d.dataset.sectionId : null; }

  function variantIdOf(comp){
    var sel = comp.querySelector('[data-ref="variant-select"]');
    if (sel && sel.value) return String(sel.value);
    var opt = comp.querySelector('[data-ref="variant-select"] option');
    if (opt && opt.value) return String(opt.value);
    var byName = comp.querySelector('[name="id"]');
    if (byName && byName.value) return String(byName.value);
    var dv = comp.querySelector('[data-variant-id]');
    if (dv && dv.getAttribute('data-variant-id')) return String(dv.getAttribute('data-variant-id'));
    return null;
  }

  // Comme Minopia (_hidden_vids) : l'assurance reste une vraie ligne de panier
  // facturée, mais on ne l'affiche JAMAIS comme un produit dans la liste du
  // panier — seule la case pré-cochée la représente. On masque donc sa ligne
  // (page = <cart-item>, drawer = <cart-drawer-item>) via une règle CSS :has()
  // (déclaratif, pas de flash aux re-rendus) + un repli impératif.
  var HIDE_STYLE_ID = 'cart-ins-hide-line';
  function injectHideCss(vid){
    if (!vid) return;
    var rule = 'cart-item:has(a[href*="variant=' + vid + '"]),' +
               'cart-drawer-item:has(a[href*="variant=' + vid + '"]){display:none !important}';
    var s = document.getElementById(HIDE_STYLE_ID);
    if (s) { if (s.textContent !== rule) s.textContent = rule; return; }
    s = document.createElement('style'); s.id = HIDE_STYLE_ID; s.textContent = rule;
    document.head.appendChild(s);
  }
  function hideInsuranceRows(vid){
    if (!vid) return;
    Array.prototype.slice.call(document.querySelectorAll('cart-item, cart-drawer-item')).forEach(function (row) {
      if (row.querySelector('a[href*="variant=' + vid + '"]')) row.style.display = 'none';
    });
  }

  function optoutOf(vid){ try { return sessionStorage.getItem('insOptout_' + vid) === '1'; } catch (x) { return false; } }
  // Un vrai produit est-il present ? L'assurance etant masquee cote serveur, tout
  // <cart-item>/<cart-drawer-item> rendu correspond a un vrai produit.
  function hasRealItems(){ return !!document.querySelector('cart-item, cart-drawer-item'); }
  // Etat AFFICHE cible de la case, calcule de facon SYNCHRONE (sans attendre le
  // reseau) : cochee des qu'il y a un vrai produit et pas d'opt-out.
  function paintSwitch(input, vid){ if (input.dataset.busy !== '1') input.checked = hasRealItems() && !optoutOf(vid); }

  function ensureSwitches(){
    var list = [];
    Array.prototype.slice.call(document.querySelectorAll(SCOPE)).forEach(function (comp) {
      var vid = variantIdOf(comp);
      if (!vid) return;
      var input = comp.querySelector('.cart-ins-switch__input');
      if (!input) {
        var target = comp.querySelector('.cross-sell__form') || comp.querySelector('.cross-sell__actions') || comp;
        var label = document.createElement('label');
        label.className = 'cart-ins-switch';
        label.setAttribute('aria-label', 'Assurance colis');
        input = document.createElement('input');
        input.type = 'checkbox';
        input.className = 'cart-ins-switch__input';
        input.setAttribute('data-variant-id', vid);
        // Etat optimiste fixe AVANT le premier rendu => la case apparait deja
        // cochee, aucune animation de "cochage" a l'ouverture du panier (comme Minopia).
        input.checked = hasRealItems() && !optoutOf(vid);
        var slider = document.createElement('span');
        slider.className = 'cart-ins-switch__slider';
        label.appendChild(input); label.appendChild(slider);
        target.appendChild(label);
        input.addEventListener('change', onChange);
      } else {
        paintSwitch(input, vid);
      }
      input._inDrawer = !!drawerOf(comp);
      list.push({ input: input, vid: String(vid) });
    });
    return list;
  }

  function clearBusy(input){ if (input) { input.dataset.busy = ''; input.disabled = false; } }

  // Rendu du drawer à partir des sections renvoyées PAR l'appel cart (add/change).
  // Ces sections sont rendues côté serveur au moment même de l'écriture du
  // panier => pas de décalage lecture-après-écriture (le bug qui laissait le
  // total du drawer à l'ancienne valeur avec un fetch ?sections séparé).
  function dispatchDrawer(sections, itemCount){
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { data: { sections: sections || {}, itemCount: itemCount, source: 'insurance-toggle' } } }));
  }
  function renderDrawerFromResp(input, resp){
    clearBusy(input);
    var sections = resp && resp.sections;
    if (resp && typeof resp.item_count === 'number') { dispatchDrawer(sections, resp.item_count); return; }
    // add.js ne renvoie pas item_count : on le récupère juste pour la pastille.
    fetch(CART, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) { dispatchDrawer(sections, cart.item_count); })
      .catch(function () { dispatchDrawer(sections, undefined); });
  }
  function drawerSections(inDrawer){
    if (!inDrawer) return null;
    var did = drawerSectionId();
    return did ? { sections: [did], sections_url: location.pathname } : null;
  }

  // silent = auto-ajout en arriere-plan : on ne desactive PAS la case (aucun
  // etat "grise"/chargement visible), la case reste cochee. Le garde busy suffit
  // a empecher les doubles actions.
  function addInsurance(input, silent){
    var inDrawer = input._inDrawer;
    input.dataset.busy = '1'; if (!silent) input.disabled = true;
    var body = { items: [{ id: input.dataset.variantId, quantity: 1 }] };
    var extra = drawerSections(inDrawer);
    if (extra) { body.sections = extra.sections; body.sections_url = extra.sections_url; }
    fetch(ADD, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (resp) { if (!inDrawer) { window.location.reload(); return; } renderDrawerFromResp(input, resp); })
      .catch(function (e) { console.error('[ins] add', e); autoTried[input.dataset.variantId] = false; input.checked = false; clearBusy(input); });
  }

  function removeInsurance(input){
    var inDrawer = input._inDrawer;
    input.dataset.busy = '1'; input.disabled = true;
    var body = { id: String(input.dataset.variantId), quantity: 0 };
    var extra = drawerSections(inDrawer);
    if (extra) { body.sections = extra.sections; body.sections_url = extra.sections_url; }
    fetch(CHANGE, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (resp) { if (!inDrawer) { window.location.reload(); return; } renderDrawerFromResp(input, resp); })
      .catch(function (e) { console.error('[ins] remove', e); input.checked = true; clearBusy(input); });
  }

  function onChange(e){
    var input = e.currentTarget;
    if (input.dataset.busy === '1') return;
    var vid = input.dataset.variantId;
    if (input.checked) { try { sessionStorage.removeItem('insOptout_' + vid); } catch (x) {} addInsurance(input); }
    else { try { sessionStorage.setItem('insOptout_' + vid, '1'); } catch (x) {} removeInsurance(input); }
  }

  function onCartPage(){ return !!document.querySelector('cart-component') || location.pathname.indexOf('/cart') === 0; }
  function drawerOpen(){ var d = document.querySelector('cart-drawer'); return !!(d && d.classList.contains('is-open')); }

  function reconcile(list, allowAuto){
    if (!list.length) return;
    var vid = list[0].vid;
    fetch(CART, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var items = cart.items || [];
      var real = 0, inCart = false;
      items.forEach(function (it) { if (String(it.variant_id) === vid) inCart = true; else real++; });
      var optout = false; try { optout = sessionStorage.getItem('insOptout_' + vid) === '1'; } catch (x) {}
      // Etat AFFICHE de la case = etat cible ("l'assurance est-elle active ?") :
      // cochee des qu'il y a un vrai produit et pas d'opt-out, meme si l'ajout
      // reseau n'est pas encore termine. => la case est deja cochee a l'ouverture,
      // on ne voit jamais l'animation de cochage (comme Minopia).
      var displayChecked = (real > 0 && !optout);
      list.forEach(function (o) { if (o.input.dataset.busy !== '1') o.input.checked = displayChecked; });
      // pick the switch to act through, by context (page => reload ; drawer => event refresh)
      var pageSw = null, drawSw = null;
      list.forEach(function (o) { if (o.input._inDrawer) { if (!drawSw) drawSw = o.input; } else if (!pageSw) pageSw = o.input; });
      var actor = onCartPage() ? (pageSw || drawSw) : (drawSw || pageSw);
      if (!actor || actor.dataset.busy === '1') return;

      // Panier sans vrai produit => on repart de zero : on retire l'assurance
      // auto-ajoutee, on rearme le garde-fou d'auto-ajout ET on efface l'opt-out
      // de session, pour que l'assurance se re-coche automatiquement des qu'un
      // nouveau produit est ajoute au panier.
      if (real === 0) {
        autoTried[vid] = false;
        try { sessionStorage.removeItem('insOptout_' + vid); } catch (x) {}
        if (inCart) { actor.checked = false; removeInsurance(actor); }
        return;
      }

      // Assurance deja presente : on rearme le garde-fou pour autoriser un
      // futur re-ajout automatique si elle venait a etre retiree.
      if (inCart) { autoTried[vid] = false; return; }

      // real > 0 et assurance absente : auto-ajout SILENCIEUX (case deja cochee,
      // pas d'etat de chargement), sauf opt-out actif.
      if (allowAuto && !optout && !autoTried[vid]) { autoTried[vid] = true; actor.checked = true; addInsurance(actor, true); }
    }).catch(function () {});
  }

  // Ce thème n'émet PAS d'évènement document 'cart:open' fiable : on observe
  // directement la classe .is-open du drawer pour déclencher l'auto-ajout au
  // moment exact où le panier coulissant s'ouvre (supprime toute course de timing).
  // Peint immediatement (synchrone) toutes les cases dans leur etat cible, pour
  // qu'a l'instant ou le drawer s'ouvre la case soit deja cochee (aucune anim).
  function paintAllNow(){
    Array.prototype.slice.call(document.querySelectorAll(SCOPE + ' .cart-ins-switch__input')).forEach(function (inp) {
      paintSwitch(inp, inp.dataset.variantId);
    });
  }

  function watchDrawer(){
    var d = document.querySelector('cart-drawer');
    if (!d || d.__insObserved) return;
    d.__insObserved = true;
    try {
      var mo = new MutationObserver(function () {
        if (d.classList.contains('is-open')) { paintAllNow(); setTimeout(function(){ initAll(true); }, 40); }
      });
      mo.observe(d, { attributes: true, attributeFilter: ['class'] });
    } catch (x) {}
  }

  // Le thème remplace tout le innerHTML de .cart-drawer__inner a chaque mise a
  // jour (ajout produit, ajout assurance...). La case (injectee en JS) est alors
  // detruite puis re-injectee via un setTimeout => un rendu SANS la case est
  // peint entre les deux = le "flash" de la section assurance.
  // On observe donc le contenu du drawer et on re-injecte la case de facon
  // SYNCHRONE (le callback d'un MutationObserver s'execute avant le paint), pour
  // que chaque rendu affiche deja la case : plus aucun flash.
  function watchDrawerContent(){
    var inner = document.querySelector('cart-drawer .cart-drawer__inner');
    if (!inner || inner.__insContentObserved) return;
    inner.__insContentObserved = true;
    try {
      var mo = new MutationObserver(function () {
        var comp = document.querySelector(SCOPE);
        if (!comp) return;
        if (!comp.querySelector('.cart-ins-switch__input')) ensureSwitches();
        else paintAllNow();
      });
      mo.observe(inner, { childList: true, subtree: true });
    } catch (x) {}
  }

  function initAll(allowAuto){
    watchDrawer();
    watchDrawerContent();
    var list = ensureSwitches();
    if (list.length) { injectHideCss(list[0].vid); hideInsuranceRows(list[0].vid); }
    reconcile(list, allowAuto);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ initAll(onCartPage() || drawerOpen()); });
  else initAll(onCartPage() || drawerOpen());
  document.addEventListener('cart:updated', function (e) {
    var d = (e && e.detail && e.detail.data && e.detail.data.source === 'insurance-toggle') ? 40 : 80;
    setTimeout(function(){ initAll(onCartPage() || drawerOpen()); }, d);
  });
  document.addEventListener('cart:open', function () { setTimeout(function(){ initAll(true); }, 60); });
})();
